// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1603":"npm.core-js","3773":"npm.dompurify","7383":"npm.html2canvas","8727":"npm.canvg"}[chunkId] || chunkId) + "." + {"1603":"20e8726208d8cfdf8c17","3773":"02920dac15981dbd0ef4","4964":"0194a88482da6f69a797","7383":"dbaba84e100bce9d1d6f","8727":"e0d84fcb1b60b203d19c"}[chunkId] + ".js";
};